export const Authentication = {
  client: {
    id: process.env.REACT_APP_AUTH_CLIENT_ID,
    secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
  },
};
export default Authentication;
